export default "__VITE_ASSET__BNuzTTca__"